<template>
  <div class="packs-list">
    <div class="pack-item" v-for="(pack, i) in packs" :key="i">
      <PackStoreItem
        :packId="pack.id"
        :packName="pack.title"
        :packProducts="pack.items"
        :description="pack.description"
        :price="pack.price"
        :currency="currency"
        :imageUrl="pack.image_url"
        :isLoading="loadingPacks[pack.id]"
        @purchase="handlePurchase"
      />
    </div>
  </div>
</template>

<script>
import { ref } from "vue";
import PackStoreItem from "./PackStoreItem.vue";

export default {
  name: "PacksList",
  components: {
    PackStoreItem,
  },
  props: {
    packs: {
      type: Array,
      required: true,
    },
    currency: {
      type: String,
      required: true,
    },
  },
  emits: ["purchase"],
  setup(props, { emit }) {
    const loadingPacks = ref({});

    const handlePurchase = (packData) => {
      loadingPacks.value[packData.packId] = true;
      emit("purchase", packData);

      // Reset loading state after a timeout (in case of errors)
      setTimeout(() => {
        loadingPacks.value[packData.packId] = false;
      }, 5000);
    };

    return {
      loadingPacks,
      handlePurchase,
    };
  },
};
</script>

<style scoped>
.packs-list {
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
  flex-wrap: wrap;
  position: relative;
  margin: 32px auto 0;
}

@media (max-width: 768px) {
  .packs-list {
    gap: 16px;
  }
}
</style>
